import React from 'react';
import { products } from '../data/products';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';
import ProductCard from './ProductCard';

function ProductCatalog({ onProductClick }) {
  const { t } = useLanguage();

  return (
    <section id="products" className="product-catalog">
      <div className="container">
        <h2 className="section-title">{t(translations.productCatalog.title)}</h2>
        <p className="section-subtitle">
          {t(translations.productCatalog.subtitle)}
        </p>

        <div className="products-grid">
          {products.heaters.map((product) => (
            <ProductCard
              key={product.id}
              product={product}
              onClick={onProductClick}
            />
          ))}
        </div>

        <div className="tech-info">
          <h3>{t(translations.productCatalog.techTitle)}</h3>
          <p>
            {t(translations.productCatalog.techIntro)}
          </p>
          <ul>
            {translations.productCatalog.techPoints.map((point, index) => (
              <li key={index} dangerouslySetInnerHTML={{ __html: t(point) }} />
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default ProductCatalog;
